import React from "react";
import { Link } from "react-router-dom";

export default class ModelCategory extends React.Component {
  render() {
    const items = this.props.categoryItems || [];

    const CategoryLink = (item) => (
      <Link
        key={item.id}
        to={`/model/${item.id}/`}
        className={`
            d-block text-dark text-hover-primary py-2 px-3
            ${this.props.categoryId === item.id && "bg-light"}
        `}
      >
        {item.name}
      </Link>
    );

    return (
      <>
        {CategoryLink({ id: "any", name: "Любая категория" })}
        {items.map((item) => {
          return CategoryLink(item);
        })}
      </>
    );
  }
}
